import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import type { SportsCmsBannerWidgetConfig } from '../config';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { SportsCmsBannerWidgetState } from './types';

export interface SportsCmsBannerWidgetModel
  extends WidgetModelConfig<SportsCmsBannerWidgetConfig, SportsCmsBannerWidgetState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsCmsBannerWidgetModel: SportsCmsBannerWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsCmsBannerWidget: UseWidget<
  SportsCmsBannerWidgetConfig,
  SportsCmsBannerWidgetModel
> = useWidget;
